<template>
  <v-dialog scrollable persistent width="700px" :value="show">
    <v-card class="pa-0 ma-0">
      <v-card-title class="pt-8 blue-grey--text text--darken-2 h6">
        {{ title }}
      </v-card-title>

      <v-card-text class="pa-0 pt-1">
        <v-form ref="columnForm">
          <ColumnForm class="mx-6" :column="value" @change="handleChange" />
        </v-form>
      </v-card-text>

      <v-card-actions class="px-6 py-4 justify-end">
        <Button
          plain
          color="blueGrey"
          :text="$t('common.button.cancel')"
          @click="$emit('close')"
        />
        <Button
          color="primary"
          :text="$t('common.button.save')"
          @click="handleSave"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'
import ColumnForm from '@/components/CreateBoardColumn/ColumnForm.vue'
export default {
  name: 'BoardColumnModal',

  components: {
    Button,
    ColumnForm,
  },

  props: {
    show: Boolean,
    title: String,
    value: {
      type: Object,
      default: null,
    },
  },

  data() {
    return { column: null }
  },

  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.column = { ...newValue }
      },
    },
  },

  methods: {
    validate() {
      return this.$refs.columnForm.validate()
    },

    handleSave() {
      const valid = this.validate()
      if (!valid) return
      this.$emit('save', this.column)
      this.$emit('close')
    },

    handleChange(column) {
      this.column = { ...this.value, ...column }
    },
  },
}
</script>
